<script setup>
import { __, formatDate, handleDocumentClick } from '@/utils';
import documentsFilters from '@components/documentsFilters/documentsFilters.vue'; 
import Table from '@components/table/table.vue';
import { ref, watch } from 'vue'

const props = defineProps({
    items: {
        type: Array,
        required: true
    }
});

const displayedDocuments = ref([]);
const headings = [
    __('date'),
    // __('phone number'),
    __('document name'),
    __('action'),
];

const handleDocumentsFiltration = (data) => {
    const { startDate, endDate, search } = data;

    displayedDocuments.value = props.items.filter((item) => {
        const documentDate = new Date(item.date_created);
        const isDateValid = startDate instanceof Date && !isNaN(startDate) &&
                            endDate instanceof Date && !isNaN(endDate);
        const isSearchValid = search && search.trim().length > 0;

        if (isDateValid && isSearchValid) {
            return documentDate >= startDate && documentDate <= endDate &&
                   ((item.name && item.name.toLowerCase().includes(search.toLowerCase())) ||
                    (item.description && item.description.toLowerCase().includes(search.toLowerCase())));
        } else if (isDateValid) {
            return documentDate >= startDate && documentDate <= endDate;
        } else if (isSearchValid) {
            return (item.name && item.name.toLowerCase().includes(search.toLowerCase())) ||
                   (item.description && item.description.toLowerCase().includes(search.toLowerCase()));
        }
        return true;
    });
};



watch(() => props.items,async (newItems) => {
    if (newItems && newItems.length) {
        displayedDocuments.value = newItems;
    }
},{ immediate: true });
</script>

<template>
    <div class="scroll-filters">
        <h5 class="scroll-filters__title">{{ __('Documents and Terms of Engagement') }}</h5>
        <div class="cellular-phone-wrapper">
            <documentsFilters
                :items="items"
                :showSearch="true"
                :btnClass="'btn'"
                @filtered="handleDocumentsFiltration"
                :isInvoice="false"
            />
        </div>
    </div>
    <Table 
        :headings="headings"
        :items="displayedDocuments"
        v-if="displayedDocuments?.length"
    >
        <template #default="{ item, index }">
            <td>{{ formatDate(item?.date_created) }}</td>
            <!-- <td></td> -->
            <td>{{ item?.name }}</td>
            <td>
                <a href="#" class="link-icon" target="_blank"  @click.prevent="handleDocumentClick(item?.document_id)">
                    <img :src="`${theme_path.url}/resources/images/svg/icon-download.svg`" /> 
                    {{ __('Download') }}
                </a>
            </td>
        </template>
    </Table>
</template>
